module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgMTAgNSI+CiAgPHBhdGggaWQ9IlBvbHlnb25fMSIgZGF0YS1uYW1lPSJQb2x5Z29uIDEiIGQ9Ik01LDBsNSw1SDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCA1KSByb3RhdGUoMTgwKSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./fe/web-warehouse/src/js/components/UnifiedCookiesPolicy/img/arrow.svg
// module id = 384
// module chunks = 57